<mat-drawer-container class="vh-100">
  <mat-drawer #drawer mode="side" class="bg-itec">
    <app-side-nav (closeDawer)="closeDrawer()"></app-side-nav>
  </mat-drawer>
  <mat-drawer-content>
    <nav class="px-3 navbar navbar-expand-sm fixed-top navbar-dark bg-itec app-nav">
      <div class="navbar-brand">
        <button class="navbar-toggler flex-column mb-2 mb-sm-0 d-inline-block d-md-none" type="button"
          (click)="drawer.toggle()">
          <span class="sr-only">Toggle drawer</span>
          <i class="material-icons">menu</i>
        </button>
        <span class="flex-column ms-2">
          <img class="itec-header-logo" alt="djocka" src="assets/images/itechnovative-header-logo.svg">
        </span>
      </div>
      <div class="nav ms-auto">
        <ul class="nav navbar-nav d-none d-md-flex">
          <li class="nav-item">
            <a [routerLink]="['/home']" routerLinkActive="router-link-active"
              class="nav-link">{{'itechnov.menu.home.link' | translate}}</a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/about-us']" routerLinkActive="router-link-active"
              class="nav-link">{{'itechnov.menu.aboutus.link' | translate}}</a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/contact-us']" routerLinkActive="router-link-active"
              class="nav-link">{{'itechnov.menu.contactus.link' | translate}}</a>
          </li>
        </ul>
        <div class="d-inline-block">
          <div class="d-inline px-1">
            <input type="button" class="btn btn-raised text-white" (click)="switchToEnglish()" value="{{'itechnov.language.english' | translate}}">
          </div>
          <div class="d-inline px-1">
            <input type="button" class="btn btn-raised text-white" (click)="switchToFrench()" value="{{'itechnov.language.french' | translate}}">
          </div>
        </div>
      </div>
    </nav>
    <main role="main" class="app-main">
      <div class="d-flex flex-column p-3">
        <div>
          <img src="assets/images/itechnovative-banner-img.svg" alt="itechnovative innovation technology">
        </div>
        <div class="text-justify pt-3">
          <router-outlet></router-outlet>
        </div>
      </div>
    </main>
    <footer class="sticky-bottom bg-itec text-white">
      <div class="px-3 navbar navbar-white">
        <div>
          <img class="itec-footer-img" src="assets/images/itechnovative-footer-logo.png"
            alt="itechnovative innovation technology">
        </div>
        <div>
          <div>{{'itechnov.footer.useful.links' | translate}}</div>
          <div>
            <a [routerLink]="['/']" routerLinkActive="router-link-active" class="text-white">
              {{'itechnov.footer.home.link' | translate}}</a>
          </div>
          <div>
            <a [routerLink]="['/about-us']" routerLinkActive="router-link-active" class="text-white">
              {{'itechnov.footer.aboutus.link' | translate}}</a>
          </div>
          <div>
            <a [routerLink]="['/contact-us']" routerLinkActive="router-link-active" class="text-white">
              {{'itechnov.footer.contactus.link' | translate}}
            </a>
          </div>
        </div>
        <div class="pt-3 pt-sm-0">
          <div>{{'itechnov.footer.followus.social.links' | translate}}</div>
          <div class="nav navbar-nav flex-row itec-social-media-icons">
            <a class="fa-stack fa-lg text-dark" href="https://www.linkedin.com/company/itechnovative" target="_blank">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i class="fa fa-linkedin fa-stack-1x fa-inverse"></i>
            </a>
            <a class="fa-stack fa-lg text-dark"
              href="https://www.facebook.com/Itechnovative-Limited-1101620116545638/?view_public_for=1101620116545638"
              target="_blank">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
            </a>
            <a class="fa-stack fa-lg text-dark" href="https://twitter.com/itechnovative" target="_blank">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i class="fa fa-twitter fa-stack-1x fa-inverse"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="px-3">
        <span translate="itechnov.footer.copyright" [translateParams]="{date: today}"></span>
      </div>
    </footer>
  </mat-drawer-content>
</mat-drawer-container>